import { SpatialLevelUpdateUseCase } from "@admin/domain/usecases/spatial-level-update.usecase";
import type { SpatialLevelModalFormValuesValidated } from "@admin/presentation/components/spatial-level-modal/spatial-level-modal-form.view";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { Nullable } from "@core/domain/types/nullable.type";
import { LoadLayoutStore } from "@core/presentation/components/feedback/load-layout/load-layout.store";
import { BaseViewModel } from "@iot-platform/core";
import type { SpatialLevelUpdate } from "@station/domain/models/spatial-level.model";
import { SpatialLevel } from "@station/domain/models/spatial-level.model";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class SpatialLevelUpdateModalViewModel extends BaseViewModel {
    @observable
    initialLoading = true;

    @observable
    spatialLevel: Nullable<Readonly<SpatialLevel>> = null;

    constructor(
        @inject(SpatialLevelUpdateUseCase)
        private readonly spatialLevelUpdateUseCase: SpatialLevelUpdateUseCase,
    ) {
        super();
        makeObservable(this);
    }

    override didMount(): void {
        this.initViewData();
    }

    @action
    initViewData(): void {
        runInAction(() => {
            this.initialLoading = false;
        });
    }

    @action
    async updateSpatialLevel(
        values: SpatialLevelModalFormValuesValidated,
    ): Promise<Nullable<SpatialLevel>> {
        LoadLayoutStore.start();

        const spatialLevelData: SpatialLevelUpdate = {
            id: Number(values.id.value),
            name: values.name,
        };

        const spatialLevelUpdated =
            await this.spatialLevelUpdateUseCase.execute(
                values.id.value,
                spatialLevelData,
            );

        if (spatialLevelUpdated) {
            ToastManagerRepository.success();
        }

        LoadLayoutStore.finish();

        return spatialLevelUpdated;
    }

    @action
    setSpatialLevel(spatialLevel: Readonly<SpatialLevel>): void {
        runInAction(() => {
            this.spatialLevel = spatialLevel;
        });
    }
}
